import React, { useEffect } from "react";
import { profileSuccess } from "../reducers/authReducer";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
const CallbackPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        handleRedirect()
    })

    const handleRedirect = () => {
        navigate("/")
    }
    return (

        <h1 className="page-loader-center">Loading .....</h1>
    );

}
const mapStateToProps = ({ oidc }) => {
    return { oidc }
}
const mapDispatchToProps = dispatch => {
    return { updateProfile: (info) => { dispatch(profileSuccess(info)) } }
}
export default connect(mapStateToProps, mapDispatchToProps)(CallbackPage);